<template>
  <td
    ref="cellLayout"
    @mouseover="$emit('hover')"
    @mousedown="$emit('mousedown')"
    @mousemove="$emit('mouseDrag')"
    @mouseup="$emit('mouseup')"
    @keydown="$emit('keydown', $event)"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @dblclick="$emit('dblclick')"
    tabindex="0"
    aria-disabled="true"
    :class="{
      chosen: chosen,
      sticky: sticky,
    }"
    :style="{
      top: 0,
      left: `${beforeColumnsWidth}px`,
      backgroundColor: backgroundColor,
      height: `${this.height}px`,
      minWidth: `${this.width}px`,
      textAlign: this.textAlign,
      paddingTop: `${this.paddingTop}px`,
      paddingRight: `${this.paddingRight}px`,
      paddingBottom: `${this.paddingBottom}px`,
      paddingLeft: `${this.paddingLeft}px`,
    }"
  >
    <div style="position: relative">
      <slot name="column-bulk-select"></slot>
      <slot name="row-bulk-select"></slot>
    </div>
    <div style="min-height: 20px; min-width: 30px; position: relative">
      <div
        v-if="!editing"
        v-html="cell.content"
        style="user-select: none; pointer-events: none"
      ></div>
      <cell-editor
        v-else
        :html="cell.content"
        :focus="editing"
        @change="(value) => $emit('change', value)"
        @focus="$emit('focus')"
        @blur="$emit('editor-blur')"
      />
    </div>
  </td>
</template>

<script>
import CellEditor from './cellEditor'
export default {
  name: 'Cell',
  components: { CellEditor },
  props: {
    cell: {
      type: Object,
      required: true
    },
    chosen: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: false
    },
    beforeColumnsWidth: {
      type: Number,
      default: 0
    }
  },
  watch: {
    chosen (value) {
      if (value) {
        this.$refs.cellLayout.focus()
      }
    }
  },
  computed: {
    height () {
      return this.cell.style ? this.cell.style.height : 0
    },
    width () {
      return this.cell.style ? this.cell.style.width : 0
    },
    backgroundColor () {
      return this.cell.style ? this.cell.style.backgroundColor : ''
    },
    textAlign () {
      return this.cell.style ? this.cell.style.textAlign : ''
    },
    paddingTop () {
      return this.cell.style ? this.cell.style.paddingTop : 0
    },
    paddingRight () {
      return this.cell.style ? this.cell.style.paddingRight : 0
    },
    paddingBottom () {
      return this.cell.style ? this.cell.style.paddingBottom : 0
    },
    paddingLeft () {
      return this.cell.style ? this.cell.style.paddingLeft : 0
    }
  }
}
</script>

<style scoped>
.chosen {
  opacity: 1;
  box-shadow: 0 0 0 2px rgba(49, 94, 217, 1) inset;
}

td:focus-visible {
  outline: 1px solid rgba(0, 0, 0, 0);
}

.sticky {
  z-index: 5;
  border: 3px solid #aaa;
}
</style>
